import { meta } from "./meta.js";
const ensureScriptLoaded = _ref => {
  let {
    apiKey
  } = _ref;
  let snippet = document.getElementById(meta.scriptId);
  if (!snippet) {
    snippet = document.createElement('script');
    snippet.id = meta.scriptId;
    snippet.src = meta.scriptSrc(apiKey);
    snippet.async = true;
    document.head.appendChild(snippet);
    const promise = new Promise((resolve, reject) => {
      snippet.addEventListener('load', resolve, {
        once: true
      });
      snippet.addEventListener('error', reject, {
        once: true
      });
    });
    snippet[zScriptPromise] = promise;
    return promise;
  }
  if (snippet[zScriptPromise]) {
    return snippet[zScriptPromise];
  }
  return globalThis.zE ? Promise.resolve() : Promise.reject(new Error('Zendesk script already loaded but did not find zE global'));
};
const zEPrivateGlobal = Symbol.for('@tkww/orion-web-ext-zendesk/zEPrivateGlobal');
const zScriptPromise = Symbol.for('@tkww/orion-web-ext-zendesk/zScriptPromise');
const globals = function () {
  let assign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  globalThis[zEPrivateGlobal] = globalThis[zEPrivateGlobal] || {
    proxy: null,
    isLoading: false,
    isLoaded: false,
    config: {
      loading: process.env.ORION_WEB_ZENDESK_LOADING ?? process.env.REACT_APP_ORION_WEB_ZENDESK_LOADING ?? 'lazy'
    },
    q: []
  };
  return Object.assign(globalThis[zEPrivateGlobal], assign);
};
export const configure = props => {
  const {
    config
  } = globals();
  Object.assign(config, props);
};
export const getProxy = () => {
  var _globalThis$zEPrivate;
  if ((_globalThis$zEPrivate = globalThis[zEPrivateGlobal]) !== null && _globalThis$zEPrivate !== void 0 && _globalThis$zEPrivate.proxy) {
    return globals().proxy;
  }
  const eventTarget = new EventTarget();
  const load = () => {
    const {
      config,
      isLoaded,
      isLoading
    } = globals();
    if (isLoaded || isLoading) {
      return;
    }
    globals({
      isLoading: true
    });
    eventTarget.dispatchEvent(new CustomEvent('loadingStateChange', {
      detail: {
        isLoading: true
      }
    }));
    ensureScriptLoaded({
      apiKey: config.apiKey
    }).then(() => {
      const {
        q
      } = globals({
        isLoaded: true
      });
      if (Array.isArray(q)) {
        q.forEach(args => {
          globalThis.zE(...args);
        });
        q.splice(0);
        globals({
          q: {
            push: args => globalThis.zE(...args)
          }
        });
      }
      globalThis.zE(() => {
        globals({
          isLoading: false
        });
        eventTarget.dispatchEvent(new CustomEvent('loadingStateChange', {
          detail: {
            isLoading: false
          }
        }));
      });
    }).catch(err => {
      eventTarget.dispatchEvent(new CustomEvent('error', {
        detail: err
      }));
      globals({
        isLoading: false
      });
      eventTarget.dispatchEvent(new CustomEvent('loadingStateChange', {
        detail: {
          isLoading: false
        }
      }));
    });
  };
  const zE = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return globals().q.push(args);
  };
  zE('messenger:on', 'open', () => {
    eventTarget.dispatchEvent(new CustomEvent('open'));
  });
  zE('messenger:on', 'close', () => {
    eventTarget.dispatchEvent(new CustomEvent('close'));
  });
  zE('messenger:on', 'unreadMessages', count => {
    eventTarget.dispatchEvent(new CustomEvent('unreadMessages', {
      detail: {
        count
      }
    }));
  });
  zE('messenger:set', 'locale', 'en');
  zE('messenger:set', 'zIndex', 21);
  zE('messenger', 'show');
  const loadWrap = fn => {
    return function () {
      if (config.loading === 'lazy') {
        load();
      }
      fn(...arguments);
    };
  };
  const {
    config,
    proxy
  } = globals({
    proxy: {
      addEventListener: eventTarget.addEventListener.bind(eventTarget),
      removeEventListener: eventTarget.removeEventListener.bind(eventTarget),
      load,
      show: loadWrap(() => {
        zE('messenger', 'show');
      }),
      hide: loadWrap(() => {
        zE('messenger', 'hide');
      }),
      open: loadWrap(() => {
        zE('messenger', 'open');
      }),
      close: loadWrap(() => {
        zE('messenger', 'close');
      }),
      set zIndex(value) {
        zE('messenger:set', 'zIndex', value);
      },
      set locale(value) {
        zE('messenger:set', 'locale', value);
      },
      get isLoading() {
        return globals().isLoading;
      }
    }
  });
  if (config.loading === 'eager') {
    load();
  }
  return proxy;
};